import React from 'react';
import {BaseIconProps} from '../../types';

export const BasePackage: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5H20C21.3807 2.5 22.5 3.61929 22.5 5V18C22.5 19.3807 21.3807 20.5 20 20.5H4C2.61929 20.5 1.5 19.3807 1.5 18V5C1.5 3.61929 2.61929 2.5 4 2.5H7H10ZM10 4H7V10L8.5 9L10 10V4ZM5.5 4H4C3.44772 4 3 4.44772 3 5V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V5C21 4.44772 20.5523 4 20 4H11.5V10C11.5 10.5532 11.1955 11.0615 10.7078 11.3225C10.2201 11.5835 9.62823 11.5549 9.16795 11.2481L8.5 10.8028L7.83205 11.2481C7.37177 11.5549 6.77995 11.5835 6.29221 11.3225C5.80448 11.0615 5.5 10.5532 5.5 10V4ZM5.75 16C5.75 15.5858 6.08579 15.25 6.5 15.25H11.5C11.9142 15.25 12.25 15.5858 12.25 16C12.25 16.4142 11.9142 16.75 11.5 16.75H6.5C6.08579 16.75 5.75 16.4142 5.75 16Z"
        fill={color}
      />
    </svg>
  );
};
